import { configureStore } from '@reduxjs/toolkit';
import selectedFeatureReducer from './slices/selectedFeatureSlice';
import dashboardReducer  from './slices/loteDataDashboardSlice';
import progressServiceReducer from './slices/progressServiceDashboardSlice'
import zIndexReducer from './slices/zIndexLayerSlice.js';

export const store = configureStore({
    reducer: {
        selectedFeature: selectedFeatureReducer,
        dashboard: dashboardReducer,
        progressService: progressServiceReducer,
        zIndex: zIndexReducer
    }
});